import { client } from './client';

interface ContactFormData {
  name: string;
  email: string;
  message: string;
}

export async function submitContactForm(data: ContactFormData) {
  try {
    console.log('Attempting to submit contact form with data:', data);
    console.log('Sanity client config:', {
      projectId: client.config().projectId,
      dataset: client.config().dataset,
      apiVersion: client.config().apiVersion,
      useCdn: client.config().useCdn,
      hasToken: !!client.config().token,
    });

    const result = await client.create({
      _type: 'contact',
      name: data.name,
      email: data.email,
      message: data.message,
      submittedAt: new Date().toISOString(),
      status: 'new',
    });

    console.log('Contact form submitted successfully:', result);
    return { success: true, data: result };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    if (error instanceof Error) {
      console.error('Error details:', {
        message: error.message,
        name: error.name,
        stack: error.stack,
      });
    }
    return { success: false, error };
  }
} 